import { DynamicFormV2Palette } from "@mui/material";

export type FormCheckboxComponentTokenType = {
  backgroundColor: string;
  hoverBorderColor: string;
  borderColor: string;
  fill: string;
  focusOutlineColor: string;
  iconColor: string;
};

export const assignCheckboxComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    backgroundColor: isLightMode ? formsPalette.surface.reverse : formsPalette.surface.supershy,
    hoverBorderColor: formsPalette.border.brand,
    focusOutlineColor: formsPalette.border.quiet,
    borderColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.intense,
    fill: isLightMode ? formsPalette.surface.intense : formsPalette.surface.reverse,
    iconColor: formsPalette.text.reverse,
  } as FormCheckboxComponentTokenType;
};
